// extracted by mini-css-extract-plugin
export default {"search_list":"SearchList_search_list__iE-Sg","search_mobile":"SearchList_search_mobile__gEnn-","icon":"SearchList_icon__ilMCB","cancel":"SearchList_cancel__jisCh"};